import type { ReactElement, SVGProps } from 'react';

export const createIcon =
  (viewBox: string, svgContent: ReactElement) =>
  // eslint-disable-next-line react/display-name
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox={viewBox}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {svgContent}
    </svg>
  );
